import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiConfiguration } from '../app.config';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OrderProductDetailService {

  constructor(
    private http: HttpClient,
  ) { }


  getEstimatedDelivery(documentNumber: string){
    const url = environment.url + "/v1/date-estimated/date/"+ documentNumber;
    return this.http.get<any>(url);
  }


  getLastOrderCoordinates(internalOrderNumber: string){
    const url = environment.url + "/v1/tracking/getLastCoordinate/"+ internalOrderNumber;
    return this.http.get<any>(url);
  }

}
